import React from 'react';
import ClientsTable from '@/features/dashboard/clients/components/ClientsTable.tsx';

const ClientsPage = () => {
  return <ClientsTable />;
};

export default ClientsPage;
